import { api } from '../config/api'
import { defaultPageSize } from '../utils/constants'
import { generateFilters } from '../utils/filters'

const skillsBaseEndpoint = '/SkillApi'
const agesBaseEndpoint = '/AgeRangeApi'
const odsBaseEndpoint = '/ODSApi'

export const getSkills = () => api.get(skillsBaseEndpoint)

export const getAgeRanges = () => api.get(agesBaseEndpoint)

export const getAllOds = () => api.get(`${odsBaseEndpoint}/GetAll`)

export const getOds = (pageNumber = 0, pageSize = defaultPageSize, filters) => {
  const params = generateFilters(pageNumber, pageSize, filters)
  return api.get(`${odsBaseEndpoint}/GetAllFiltered?${params.toString()}`)
}
